import * as tslib_1 from "tslib";
import * as React from 'react';
import { classNamesFunction } from '../../Utilities';
import { GroupSpacer } from './GroupSpacer';
var getClassNames = classNamesFunction();
var GroupFooterBase = /** @class */ (function (_super) {
    tslib_1.__extends(GroupFooterBase, _super);
    function GroupFooterBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupFooterBase.prototype.render = function () {
        var _a = this.props, group = _a.group, groupLevel = _a.groupLevel, footerText = _a.footerText, indentWidth = _a.indentWidth, styles = _a.styles, theme = _a.theme;
        var classNames = getClassNames(styles, { theme: theme });
        if (group && footerText) {
            return (React.createElement("div", { className: classNames.root },
                React.createElement(GroupSpacer, { indentWidth: indentWidth, count: groupLevel }),
                footerText));
        }
        return null;
    };
    return GroupFooterBase;
}(React.Component));
export { GroupFooterBase };
//# sourceMappingURL=GroupFooter.base.js.map